import { useEffect, type PropsWithChildren } from 'react';
import { getConfig } from '@petseo/shared';
import { usertourService } from '@/services/usertour.service';
import { useUsertourIdentity } from '@/hooks/useUsertourIdentity';

function UsertourIdentityBridge() {
  useUsertourIdentity();
  return null;
}

export function UsertourProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const config = getConfig();
    usertourService.init(config.usertourToken, { host: config.usertourHost });
  }, []);

  return (
    <>
      <UsertourIdentityBridge />
      {children}
    </>
  );
}
